import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LastPageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"last_page"}/>
}
